/**
 * usePageMeta.js — updates document head per route (Vue SPA).
 */
import { DEFAULT_SEO, ROUTE_SEO, SITE_URL } from '../config/seo.js';

function upsertMeta(attr, key, content) {
  if (typeof document === 'undefined' || !content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (typeof document === 'undefined' || !href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applyPageMeta(route) {
  const name = route.name ?? 'home';
  const routeSeo = ROUTE_SEO[name] ?? ROUTE_SEO.home;
  const title = route.meta?.title ?? routeSeo.title ?? DEFAULT_SEO.title;
  const description = route.meta?.description ?? routeSeo.description ?? DEFAULT_SEO.description;
  const path = route.path === '/' ? '' : route.path;
  const url = `${SITE_URL}${path}`;
  const image = `${SITE_URL}${DEFAULT_SEO.ogImage}`;

  document.title = title;
  upsertMeta('name', 'description', description);
  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:image', image);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:site_name', DEFAULT_SEO.siteName);
  upsertMeta('name', 'twitter:card', DEFAULT_SEO.twitterCard);
  upsertMeta('name', 'twitter:title', title);
  upsertMeta('name', 'twitter:description', description);
  upsertMeta('name', 'twitter:image', image);
  upsertLink('canonical', url);
}

export function initPageMeta(router) {
  router.afterEach((to) => applyPageMeta(to));
}
